"use strict";

require('./CompanyDeviationWatcherService.js');

CompanyDeviationWatcherEditCtrl.$inject = [
  '$scope',
  '$state',
  '$stateParams',
  '$translate',
  'deviationWatcher',
  'CompanyUserService',
  'CompanyDeviationWatcherService',
  'growl'
];

function CompanyDeviationWatcherEditCtrl(
  $scope,
  $state,
  $stateParams,
  $translate,
  deviationWatcher,
  CompanyUserService,
  CompanyDeviationWatcherService,
  growl) {

  $scope.categories = [
    'OLYCKA',
    'FORBATTRINGAR',
    'REKLAMATIONER',
    'TILLBUD',
    'AVVIKELSE',
    'EKONOMI',
    'KUND',
    'LEVERANTOR',
    'MILJO'
  ];

  $scope.deviationWatcher = deviationWatcher;

  var nonWatchersPromise;
  $scope.nonWatchers             = [];

  $scope.updateNonWatchers = function(filter) {
    var p = CompanyUserService.query({companyId: $stateParams.companyId, q: filter, limit: 6}).$promise.then(function(users) {
      return users.filter(function(item) {
        return !$scope.deviationWatcher.watcher.some(function(watcher) {
          return item.id === watcher.id;
        });
      });
    }).then(function(nonWatchers) {
      if(nonWatchersPromise === p) {
        $scope.nonWatchers = nonWatchers;
      }
    });
    
    nonWatchersPromise = p;
  };

  $scope.deleteWatcher = function(watcher) {
    $scope.deviationWatcher.watcher.splice($scope.deviationWatcher.watcher.indexOf(watcher), 1);
  };

  $scope.save = function() {
    CompanyDeviationWatcherService.update({companyId: $stateParams.companyId, deviationWatcherId: $stateParams.deviationWatcherId}, $scope.deviationWatcher, function() {
      growl.addSuccessMessage($translate.instant('deviation.update-deviation-watcher-success'));
      $state.go('^.list');
    },
    function() {
      growl.addErrorMessage($translate.instant('deviation.update-deviation-watcher-failure'));
    });
  };

}

CompanyDeviationWatcherEditCtrl.resolve = {
  deviationWatcher: ['CompanyDeviationWatcherService', '$stateParams', function(CompanyDeviationWatcherService, $stateParams) {
    return CompanyDeviationWatcherService.get({companyId: $stateParams.companyId, deviationWatcherId: $stateParams.deviationWatcherId}).$promise;
  }]
};

module.exports = CompanyDeviationWatcherEditCtrl;

angular.module('dokiv')
  .controller('CompanyDeviationWatcherEditCtrl', CompanyDeviationWatcherEditCtrl);


//////////////////
// WEBPACK FOOTER
// ./scripts/company/deviation-watchers/CompanyDeviationWatcherEditCtrl.js
// module id = 338
// module chunks = 0